import { IconProps } from 'src/utils/icon';

const SignOutAccountIcon: React.FC<IconProps> = ({
  size = 1,
  fill = '#2C2A29',
}) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M7.10948 7.78378C9.16948 7.78378 10.839 6.04155 10.839 3.89189C10.839 1.74223 9.16948 0 7.10948 0C5.04949 0 3.37993 1.74223 3.37993 3.89189C3.37993 6.04155 5.04949 7.78378 7.10948 7.78378ZM9.72017 8.75676H9.23358C8.58673 9.06689 7.86705 9.24324 7.10948 9.24324C6.35192 9.24324 5.63514 9.06689 4.98538 8.75676H4.49879C2.33682 8.75676 0.582764 10.5872 0.582764 12.8432V14.1081C0.582764 14.9139 1.20921 15.5676 1.98135 15.5676H12.2376C13.0098 15.5676 13.6362 14.9139 13.6362 14.1081V12.8432C13.6362 10.5872 11.8821 8.75676 9.72017 8.75676Z"
        fill={fill}
      />
      <g clipPath="url(#clip1)">
        <path
          d="M14.25 6.01776V7.45948H10.8348C10.1339 7.45948 9.58496 8.03096 9.58496 8.71624V10.7433C9.58496 11.4285 10.1339 12 10.8348 12H14.25V13.4396C14.25 14.5405 15.5871 15.1368 16.3877 14.3254C16.3878 14.3254 16.3878 14.3253 16.3879 14.3253L20.0528 10.6158L20.0533 10.6154C20.5371 10.1249 20.5371 9.33465 20.0533 8.84413L20.053 8.84383L16.3876 5.13183L16.3861 5.13038C15.5848 4.3233 14.25 4.91502 14.25 6.01776Z"
          fill={fill}
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
    </g>
  </svg>
);

export default SignOutAccountIcon;
